export enum ServiceRequestTypeCodeEnum {
    Issue = 'Issue',
    Renew = 'Renew',
    AddActivity = 'AddActivity',
    CancelActivity = 'CancelActivity',
    CancelLicense = 'CancelLicense'
}
